import React from "react";
import { cn } from "../../../lib/utils";

interface SelectionIndicatorProps {
  isSelected: boolean;
  isMultiple: boolean;
  className?: string;
}

export const SelectionIndicator: React.FC<SelectionIndicatorProps> = ({
  isSelected,
  isMultiple,
  className,
}) => {
  if (isMultiple) {
    return (
      <div
        className={cn(
          "w-5 h-5 border rounded-sm flex items-center justify-center",
          isSelected ? "bg-white border-white" : "border-gray-400",
          className
        )}
      >
        {isSelected && <span className="text-black text-xs font-bold">✓</span>}
      </div>
    );
  }

  return (
    <div
      className={cn(
        "w-5 h-5 rounded-full border flex items-center justify-center",
        isSelected ? "border-2 border-white" : "border border-gray-400",
        className
      )}
    >
      {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-white"></div>}
    </div>
  );
};
